<template>
  <div v-if="!isMobile()">
    <div class="box">
      <!-- measures -->
      <div v-if="!isGrouping && !isMedAdmin">
        <div class="measures-col">
          <table class="measures-grid-measures">
            <tbody class="measures-tbody">
              <tr>
                <td class="measure-in-grid-1 grid-header">Date</td>
              </tr>
              <tr
                v-for="(row, i) in sortedGrid"
                :class="{ highlight: isMeasChecked(row.ccd) }"
                :key="'vital_' + i + '_' + row.ccd"
              >
                <td class="measure-in-grid-1 measure-desc">
                  <span class="measure-entry-wrapper">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @click="handleCheckMeasure(row.ccd)"
                      :id="row.ccd"
                      :checked="checkedMeasures[row.ccd]"
                    />
                    {{ getDescByCcd(row.ccd, allData) }}
                    <button
                      v-if="!isVitalSign"
                      @click="handleRemoveMeasure(procCcd, row.ccd)"
                      class="btn btn--remove"
                    >
                      <font-awesome-icon :icon="['fas', 'times-circle']" class="icon--remove" />
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- dates -->
        <div class="values-col">
          <table class="measures-grid-values">
            <tbody class="values-tbody">
              <tr class="all-date-headers">
                <td
                  class="value-in-grid-1"
                  v-for="dateCombo in dateAndColor"
                  :key="'vital_' + dateCombo.date"
                  :class="'bg-color-' + dateCombo.alt"
                >
                  {{ dateCombo.date }}
                </td>
              </tr>
              <tr
                v-for="(row, i) in sortedGrid"
                :class="['all-rows', { highlight: isMeasChecked(row.ccd) }]"
                :key="'vital_' + i"
              >
                <td
                  v-for="(measure, date, j) in row.dateEntries"
                  :key="'vital_' + i + '_' + j"
                  class="value-in-grid-1"
                  :class="'bg-color-' + dateAndColor[j].alt"
                >
                  {{ measure ? measure.value : "" }}
                  <span v-if="measure && measure.source">
                    <img
                      class="external-measure-icon"
                      :title="measure.source"
                      :src="getSourceIconFilename(measure.source)"
                    />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="isMedAdmin">
        <table class="measures-grid-values-2">
          <tbody>
          <tr>
            <th class="measure-in-grid y-header">Date</th>
            <th
              class="measure-box"
              v-for="interval in intervals"
              :key="'header_' + interval"
            >
              <table class="time-headers">
              <tbody>
                <tr>
                  <td class="interval-header">
                    {{ interval }}
                  </td>
                </tr>
                <tr>
                  <td class="vital-heading">
                    {{ "Nebulizer" }}
                  </td>
                </tr>
              </tbody>
              </table>
            </th>
          </tr>
          <tr v-for="(row, dt) in gridifyNebData" :key="'neb_' + dt" class="alt-bg-color">
            <td class="y-header value-in-grid2">
              <b>{{ dt }}</b>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(val, ind) in row.morning"
                  :key="'neb_' + dt + ind"
                  class="values-row"
                >
                  <td class="td-value">
                    <div class="tooltip">
                      {{ Math.floor(val.data / 60) + "min " + (val.data % 60) + "sec" }}
                      <span class="tooltiptext">
                        {{ val.time }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(val, ind) in row.afternoon"
                  :key="'neb_' + dt + ind"
                  class="values-row"
                >
                  <td class="td-value">
                    <div class="tooltip">
                      {{ Math.floor(val.data / 60) + "min " + (val.data % 60) + "sec" }}
                      <span class="tooltiptext">
                        {{ val.time }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(val, ind) in row.evening"
                  :key="'neb_' + dt + ind"
                  class="values-row"
                >
                  <td class="td-value">
                    <div class="tooltip">
                      {{ Math.floor(val.data / 60) + "min " + (val.data % 60) + "sec" }}
                      <span class="tooltiptext">
                        {{ val.time }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(val, ind) in row.overnight"
                  :key="'neb_' + dt + ind"
                  class="values-row"
                >
                  <td class="td-value">
                    <div class="tooltip">
                      {{ Math.floor(val.data / 60) + "min " + (val.data % 60) + "sec" }}
                      <span class="tooltiptext">
                        {{ val.time }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="isGrouping">
        <!-- dates -->
        <!-- <div class="measures-col">
        <table class="measures-grid-measures">
          <tbody class="measures-tbody">
            <tr><td class="measure-in-grid grid-header">Date/Measures</td></tr>
            <tr v-for="(row,i) in sortedGrid" :class="{highlight: isMeasChecked(row.ccd)}" :key="'vital_'+i+'_'+row.ccd">
              <td class="measure-in-grid measure-desc">
                <span class="measure-entry-wrapper">
                  <input type="checkbox"
                  class="form-check-input"
                  @click="handleCheckMeasure(row.ccd)"
                  :id="row.ccd"
                  :checked="checkedMeasures[row.ccd]"/>
                  {{getDescByCcd(row.ccd, allData)}}
                  <button v-if="!isVitalSign" @click="handleRemoveMeasure(procCcd, row.ccd)" class="btn btn--remove"><font-awesome-icon icon="times-circle" class="icon--remove" /></button> 
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
        <!-- <span class="dateRanger"> Date range: </span> -->
        <!-- <select v-model="range">
        <option v-for="dateRange in dateRanges" v-bind:value="{id: dateRange.value, text: dateRange.name}" :key="dateRange.name">
          {{dateRange.name}}
        </option>
      </select>
      <span class="dateGrouper"> Group dates: </span>
      <select v-model="selected">
        <option v-for="dateGroup in dateGroups" v-bind:value="{id: dateGroup.value, text: dateGroup.name}" :key="dateGroup.name">
          {{dateGroup.name}}
        </option>
      </select> -->
        <table
          v-for="(dateRange, i) in sortedNewGridByTime"
          class="measures-grid-values-2"
          :key="'range_' + i"
        >
        <tbody>
          <tr>
            <th class="measure-in-grid y-header">Date</th>
            <th
              class="measure-box"
              v-for="interval in intervals"
              :key="'heading_' + interval"
            >
              <table class="time-headers">
              <tbody>
                <tr>
                  <td class="interval-header" :colspan="Object.keys(sortedGrid).length">
                    {{ interval }}
                  </td>
                </tr>
                <tr>
                  <td
                    v-for="(row, i) in sortedGrid"
                    class="vital-heading"
                    :key="'vital_' + i + '_' + row.ccd"
                  >
                    <input
                      type="checkbox"
                      @click="handleCheckMeasure(row.ccd)"
                      :id="row.ccd"
                      :checked="checkedMeasures[row.ccd]"
                    />
                    <span class="ccd-label">{{ getDescByCcd(row.ccd, allData) }}</span>
                  </td>
                </tr>
              </tbody>
              </table>
            </th>
          </tr>
          <tr v-for="(row, dt) in dateRange" :key="'vital_' + dt" class="alt-bg-color">
            <td class="y-header value-in-grid-2">
              <b>{{ switchDateOrder(dt) }}</b>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(arr, timeKey) in row.morning"
                  :key="'vital_' + timeKey"
                  class="values-row"
                >
                  <td v-for="(values, y) in arr" :key="'vital_' + y" class="td-value">
                    <div class="tooltip">
                      {{ values != undefined ? values.value : "" }}
                      <span v-if="values != undefined" class="tooltiptext">
                        {{ timeKey }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(arr, timeKey) in row.afternoon"
                  :key="'vital_' + timeKey"
                  class="values-row"
                >
                  <td v-for="(values, y) in arr" :key="'vital_' + y" class="td-value">
                    <div class="tooltip">
                      {{ values != undefined ? values.value : "" }}
                      <span v-if="values != undefined" class="tooltiptext">
                        {{ timeKey }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(arr, timeKey) in row.evening"
                  :key="'vital_' + timeKey"
                  class="values-row"
                >
                  <td v-for="(values, y) in arr" :key="'vital_' + y" class="td-value">
                    <div class="tooltip">
                      {{ values != undefined ? values.value : "" }}
                      <span v-if="values != undefined" class="tooltiptext">
                        {{ timeKey }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
            <td class="value-in-grid-2">
              <table class="data-table">
              <tbody>
                <tr
                  v-for="(arr, timeKey) in row.overnight"
                  :key="'vital_' + timeKey"
                  class="values-row"
                >
                  <td v-for="(values, y) in arr" :key="'vital_' + y" class="td-value">
                    <div class="tooltip">
                      {{ values != undefined ? values.value : "" }}
                      <span v-if="values != undefined" class="tooltiptext">
                        {{ timeKey }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
        <!-- <div class="dates-col">
        <table class="measures-grid-measures">
          <tbody class="measures-tbody">
            <tr>
              <th class="measure-in-grid grid-header">
                Measurement Date
              </th>
            </tr>
            <tr v-for="date in Object.keys(newGrid)" :key="'vital_'+date">
              <td class="measure-in-grid-2 measure-desc">
                <span class="measure-entry-wrapper">
                  {{date}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

        <!-- dates -->
        <!-- <div class="values-col">
        <table class="measures-grid-values-2">
          <tbody class="values-tbody-2">
            <tr>
              <td class="time-headers">{{"Morning (6am - 12pm)"}}</td>
              <td class="time-headers">{{"Afternoon (12am - 6pm)"}}</td>
              <td class="time-headers">{{"Evening (6pm - 12am)"}}</td>
              <td class="time-headers">{{"Overnight (12am - 6pm)"}}</td>
            </tr>
            <tr> -->
        <!-- <td v-for="(row,i) in sortedGrid" :class="{highlight: isMeasChecked()}" :key="'vital_'+i+'_'+row.ccd" class="measure-in-grid-2 measure-desc">
                <span class="measure-entry-wrapper">
                  <input type="checkbox"
                  class="form-check-input"
                  @click="handleCheckMeasure(row.ccd)"
                  :id="row.ccd"
                  :checked="checkedMeasures[row.ccd]"/>
                  {{getDescByCcd(row.ccd, allData)}}
                  <button v-if="!isVitalSign" @click="handleRemoveMeasure(procCcd, row.ccd)" class="btn btn--remove"><font-awesome-icon icon="times-circle" class="icon--remove" /></button> 
                </span>
              </td> -->
        <!-- <td v-for="i in 4" :key="'vital_'+i" class="measure-in-grid-2">
                <table class="cell-table">
                  <tr>
                    <td v-for="(row,i) in sortedGrid" class="vital-heading" :key="'vital_'+i+'_'+row.ccd">
                      {{getDescByCcd(row.ccd, allData)}}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-for="(date, i) in dates" :key="'vital_'+date+'_'+i">
              <td v-for="(row, m) in sortedGrid" class="value-in-grid-2" :class="{highlight: isMeasChecked(row.ccd)}" :key="'vital_'+m">
                {{row.dateEntries[date]?row.dateEntries[date].value:''}}
              </td>
            </tr> -->

        <!-- <tr v-for="(row,i) in sortedGrid" :class="{highlight: isMeasChecked(row.ccd)}" :key="'vital_'+i">
              <td v-for="(measure, date, j) in row.dateEntries" :key="'vital_'+i+'_'+j" class="value-in-grid" >
                {{measure?measure.value:''}}  
                <span v-if="measure && measure.source" >
                  <img 
                  class="external-measure-icon" 
                  :title="measure.source" 
                  :src="getSourceIconFilename(measure.source)">
                  </span>
              </td>
            </tr> -->
        <!-- </tbody>
        </table>
      </div> -->
      </div>
    </div>
  </div>
  <div v-else>
    <div v-for="(value, key) in newRangedGrid" :key="'grid'+key" class="bp-date-box">
      <div class="bp-date-header">{{ key }}</div>
      <div class="bp-tabs">
        <button v-if="Object.keys(value.AM).length != 0" @click="showAMData(key)" class="tab-button active">AM</button>
        <button v-if="Object.keys(value.PM).length != 0" @click="showPMData(key)" class="tab-button">PM</button>
      </div>
      <div v-if="Object.keys(value.AM).length != 0" class="vitals-content vitals-am vitals-row" :id="key+'AM'">
        <div v-for="(meas, time) in value.AM" :key="key+'date'+time">
          <label class="vitals-item">
            <span>{{ time }}</span>
            <template v-if="meas && meas.length > 0">
              <div v-for="(item, index) in meas" :key="'vitalsItemAM' + index">
                <template v-if="item && item.ccd">
                  <!-- <input type="checkbox"> -->
                  {{ getDescByCcd(item.ccd, allData) }}
                  <span>{{ item.value }}</span>
                </template>
              </div>
            </template>
          </label>
        </div>
      </div>
      <div v-if="Object.keys(value.PM).length != 0" class="vitals-content vitals-pm vitals-row" :id="key+'PM'">
        <div v-for="(meas, time) in value.PM" :key="key+'date'+time">
          <label class="vitals-item">
            <span>{{ time }}</span>
            <template v-if="meas && meas.length > 0">
              <div v-for="(item, index) in meas" :key="'vitalsItemPM' + index">
                <template v-if="item && item.ccd">
                  <!-- <input type="checkbox"> -->
                  {{ getDescByCcd(item.ccd, allData) }}
                  <span>{{ item.value }}</span>
                </template>
              </div>
            </template>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getDescByCcd, getMeasureWeightByCcd } from "@/data/getters";
import blood_pressure_device_img from "@/assets/images/devices/blood_pressure_device.png";
import scale_device_img from "@/assets/images/devices/scale_device.png";
export default {
  name: "measure-grid",
  props: {
    grid: Array,
    dates: Array,
    isVitalSign: {
      type: Boolean,
      default: false,
    },
    isMedAdmin: {
      type: Boolean,
      default: false,
    },
    isGrouping: {
      type: Boolean,
      default: false,
    },
    procCcd: {
      default: null,
    },
    selected: {
      default: null,
    },
    range: {
      type: Number,
      default: 50000,
      required: true,
    },
  },
  data() {
    return {
      intervals: ["6am - 12pm", "12pm - 6pm", "6pm - 12am", "12am - 6am"],
      // selected: '',
      // dateGroups: [
      //   {name: 'every week', value: 7},
      //   {name: 'every 2 weeks', value: 14},
      //   {name: 'every 30 days', value: 30},
      //   {name: 'every 90 days', value: 90},
      //   {name: 'every 365 days', value: 365},
      //   {name: 'all', value: 50000}
      // ],
      // range: '',
      // dateRanges: [
      //   {name: 'all', value: 50000},
      //   {name: 'last week', value: 7},
      //   {name: 'last 2 weeks', value: 14},
      //   {name: 'last 30 days', value: 30},
      //   {name: 'last 90 days', value: 90},
      //   {name: 'last 365 days', value: 365}
      // ]
    };
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    ...mapGetters("login/watch", {
      measuresWatching: "getMeasuresWatching",
      proceduresWatching: "getProceduresWatching",
      checkedMeasures: "getCheckedMeasures",
      vitalSignCodes: "getVitalSignCodes",
    }),
    dateAndColor() {
      let d = this.dates;
      let flip = 1;
      let final = [];
      if (d[0]) {
        let newDate = { date: d[0], alt: "" + flip };
        final.push(newDate);
      }
      for (var i = 1; i < d.length; i++) {
        if (d[i - 1].substring(0, 10) == d[i].substring(0, 10)) {
          let nextDate = { date: d[i], alt: "" + flip };
          final.push(nextDate);
        } else {
          flip *= -1;
          let nextDate = { date: d[i], alt: "" + flip };
          final.push(nextDate);
        }
      }
      return final;
    },
    sortedGrid() {
      return this.sortGridByCheckedAndWeight(this.grid);
    },
    newGrid() {
      let oldGrid = this.sortGridByCheckedAndWeight(this.grid);
      let grid = {};
      for (const date of this.dates) {
        let datetime = new Date(date);
        let dateKey =
          datetime.getFullYear() +
          "-" +
          (datetime.getMonth() + 1) +
          "-" +
          datetime.getDate();
        let hour = datetime.getHours();
        let time = this.setTimeLabel(hour, datetime.getMinutes());

        if (!(dateKey in grid)) {
          grid[dateKey] = { morning: {}, afternoon: {}, evening: {}, overnight: {} };
        }
        for (let vital of oldGrid) {
          let data = vital.dateEntries[date];
          if (hour < 6) {
            if (!(time in grid[dateKey]["overnight"])) {
              grid[dateKey]["overnight"][time] = [];
            }
            grid[dateKey]["overnight"][time].push(data);
          } else if (hour < 12) {
            if (!(time in grid[dateKey]["morning"])) {
              grid[dateKey]["morning"][time] = [];
            }
            grid[dateKey]["morning"][time].push(data);
          } else if (hour < 18) {
            if (!(time in grid[dateKey]["afternoon"])) {
              grid[dateKey]["afternoon"][time] = [];
            }
            grid[dateKey]["afternoon"][time].push(data);
          } else {
            if (!(time in grid[dateKey]["evening"])) {
              grid[dateKey]["evening"][time] = [];
            }
            grid[dateKey]["evening"][time].push(data);
          }
        }
      }
      return grid;
    },
    newRangedGrid() {
      let oldGrid = this.sortGridByCheckedAndWeight(this.grid);
      let grid = {};
      for (const date of this.dates) {
        let datetime = new Date(date);
        let dateKey =
          datetime.getFullYear() +
          "-" +
          (datetime.getMonth() + 1) +
          "-" +
          datetime.getDate();
        let hour = datetime.getHours();
        let time = this.setTimeLabel(hour, datetime.getMinutes());

        if (!(dateKey in grid)) {
          grid[dateKey] = { AM: {}, PM: {} };
        }
        for (let vital of oldGrid) {
          let data = vital.dateEntries[date];
          if (hour < 12) {
            if (!(time in grid[dateKey]["AM"])) {
              grid[dateKey]["AM"][time] = [];
            }
            grid[dateKey]["AM"][time].push(data);
          } else {
            if (!(time in grid[dateKey]["PM"])) {
              grid[dateKey]["PM"][time] = [];
            }
            grid[dateKey]["PM"][time].push(data);
          }
        }
      }
      return grid;
    },
    gridifyNebData() {
      let grid = {};
      if (this.grid.length == 0) return grid;
      for (let reading of this.grid) {
        let datetime = new Date(reading.MDateTimeUTC);
        datetime = datetime.toLocaleString("en-US", { timeZone: "America/New_York" });
        datetime = new Date(datetime);
        let dateKey =
          datetime.getFullYear() +
          "-" +
          (datetime.getMonth() + 1) +
          "-" +
          datetime.getDate();
        let hour = datetime.getHours();
        let time = this.setTimeLabel(hour, datetime.getMinutes());

        if (!(dateKey in grid)) {
          grid[dateKey] = { morning: [], afternoon: [], evening: [], overnight: [] };
        }
        let data = reading.MValue1;
        if (hour < 6) {
          grid[dateKey]["overnight"].push({ time: time, data: data });
        } else if (hour < 12) {
          grid[dateKey]["morning"].push({ time: time, data: data });
        } else if (hour < 18) {
          grid[dateKey]["afternoon"].push({ time: time, data: data });
        } else {
          grid[dateKey]["evening"].push({ time: time, data: data });
        }
      }
      // console.log(grid)
      return grid;
    },
    sortedNewGridByTime() {
      let data = [];
      let pivotDate = null;
      let rangedData = {};
      let time = 7;
      let today = new Date();
      if (this.selected) time = this.selected.id;
      for (let date of Object.keys(this.newGrid)) {
        if (!pivotDate) pivotDate = new Date(date);
        let date2 = new Date(date);
        if (today - date2 <= (this.range - 1) * 86400000) {
          //          break
          //        if (pivotDate - date2 > ((time - 1) * 86400000)) {
          data.push(rangedData);
          pivotDate = date2;
          rangedData = {};
        }
        rangedData[date] = this.newGrid[date];
      }
      data.push(rangedData);
      return data;
    },
  },
  beforeDestroy() {
    delete this.sortedGrid;
  },
  methods: {
    ...mapActions("login/watch", [
      "removeMeasure",
      "addCheckedMeasure",
      "removeCheckedMeasure",
    ]),
    showPMData(key){
      let amData = document.getElementById(key+'AM')
      if (amData)
        amData.style.display = 'none'
      let pmData = document.getElementById(key+'PM')
      if (pmData.style.display == 'none')
        pmData.style.display = 'flex'
      else
        pmData.style.display = 'none'
    },
    showAMData(key){
      let pmData = document.getElementById(key+'PM')
      if (pmData)
        pmData.style.display = 'none'
      let amData = document.getElementById(key+'AM')
      if (amData.style.display == 'none')
        amData.style.display = 'flex'
      else
        amData.style.display = 'none'
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    switchDateOrder(dt) {
      let obj = new Date(dt.replace(/-/g, "/"));
      return `${obj.getDate()}-${obj.getMonth() + 1}-${obj.getFullYear()}`;
    },
    /**
     * Removes measure from watch list and graph
     */
    async handleRemoveMeasure(procCcd, measCcd) {
      // console.log(this.sortedGrid)
      await this.removeCheckedMeasure(measCcd);
      await this.removeMeasure({ proc: procCcd, meas: measCcd });
    },
    /**
     * Graphs measure
     * @param measCcd currently checked measurement id
     */
    async handleCheckMeasure(measCcd) {
      // remove from list and graph if checked
      if (this.checkedMeasures[measCcd]) {
        await this.removeCheckedMeasure(measCcd);
      } else {
        await this.addCheckedMeasure(measCcd);
      }
    },
    isMeasChecked(ccd) {
      // console.log(this.allData.ccds, ccd)
      return this.checkedMeasures[ccd];
    },
    setTimeLabel(hour, min) {
      if (min < 10) min = "0" + min;
      if (hour == 0) return "12:" + min + " AM";
      if (hour == 12) return "12:" + min + " PM";
      if (hour < 12) return hour + ":" + min + " AM";
      return hour - 12 + ":" + min + " PM";
    },
    /* sort measures by isChecked then weights */
    sortGridByCheckedAndWeight(grid) {
      for (let measure of grid) {
        measure["checked"] = this.isMeasChecked(measure.ccd) ? 1 : 0;
        measure["weight"] = getMeasureWeightByCcd(measure.ccd, this.allData);
      }
      return _.orderBy(grid, ["checked", "weight"], ["desc", "desc"]);
    },
    getDescByCcd,
    getSourceIconFilename(source) {
      let iconSrc = "";
      switch (source) {
        case "BLOOD_PRESSURE_DEVICE":
          iconSrc = blood_pressure_device_img;
          break;
        case "WEIGHT_BLOOD_PRESSURE_DEVICE":
          iconSrc = scale_device_img;
          break;

        default:
          break;
      }

      return iconSrc;
    },
  },
};
</script>
<style scoped lang="scss">
// :root {
// 	--clr-primary-light: #49a5a7;
// 	--clr-primary-dark: #0c8687;
// 	--clr-bg-light: #fffeff;
// 	--clr-bg-dark: #ecf7f2;
// 	--clr-gray-dark: #999;
// 	--clr-gray-light: hsl(300, 2%, 80%);
// 	--clr-gray-lightest: hsl(300, 2%, 93%);
// 	--clr-highlight-pulse: #e97c99;
// 	--clr-highlight-systolic: #f9b560;

// 	--table-margin-inline: 0.5em;
// }
.external-measure-icon {
  height: 1.1em;
  width: 1.1em;
}

.ccd-label {
  margin-left: 8%;
  font-size: smaller;
}

.row .measures-col {
  padding-right: 0;
  float: left;
  max-width: 50%;
  overflow: auto;
}

.row .dates-col {
  padding-right: 0;
  float: left;
  max-width: 50%;
  overflow: auto;
  // overflow-y: scroll;
  // height: 400px;
}

.row .values-col {
  padding-left: 0;
  // float: right;
  overflow: auto;
}

.time-headers {
  width: 100%;
  height: 2em;
  text-align: center;
  table-layout: fixed;
}

@media only screen and (max-width: 767px) {
  .measure-box {
    width: 17%;
  }
}

.interval-header,
.td-value {
  border: none;
}

th {
  color: #fff;
  height: 4em;
  // border-width: 1px;
  // border-style: solid;
  // border-color: #242222;
}

th:nth-of-type(2n + 1) {
  background-color: #49a5a7;
}

th:nth-of-type(2n) {
  background-color: #0c8687;
}

tr.alt-bg-color:nth-of-type(2n + 1) {
  background-color: #ecf7f2;
}

tr.alt-bg-color:nth-of-type(2n) {
  background-color: #fffeff;
}

td + td {
  border-left: 1px solid #999;
}

.data-table tr:hover {
  background-color: #0c8687;
}

.data-table tr:hover .tooltip {
  color: white;
}

// .values-row:hover {

// }
// table td {
//   border-width: 1px;
//   border-style: solid;
//   border-color: #242222;
//   border-radius: 5px;
// }
td.measure-desc {
  padding-left: 1.5em;
}

.vital-heading {
  border: none;
  padding: 0px 5px 0px 10px;
  text-align: center;
}

.cell-table {
  width: 100%;
}

.data-table {
  width: 100%;
  text-align: center;
  table-layout: fixed;
}

// table.measures-grid-values td {
//   border-left: none;
// }
.measures-grid-values,
.measures-grid-values-2 {
  display: table;
  width: 100%;
  margin-bottom: 20px;
}

.measures-grid-values-2 {
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
}

.measures-gird-measures {
  // background-color: rgb(61, 44, 44);
  z-index: 1;
}

.grid-header {
  padding-left: 0.5em;
}

.y-header {
  text-align: center;
  width: 5%;
  // background-color: #e3e5e9;
}

tbody.values-tbody {
  // width: 40vw;
  display: block;
  // overflow-x: auto;
}

tbody.values-tbody-2 {
  width: 100%;
  display: table-row-group;
}

tbody.measures-tbody {
  background-color: #e3e5e9;

  white-space: nowrap;
  // width: 60%;
  display: block;
  overflow: auto;
}

td.measure-in-grid-1 {
  min-width: 175px;
  height: 2em;
  border: 1px solid;
}

td.measure-in-grid-2 {
  height: 2em;
}

td.value-in-grid-1 {
  min-width: 11em;
  height: 2em;
  text-align: center;
  border: 1px solid;
  border-left: none;
  border-right: none;
}

// td.value-in-grid-2 {
//   height: 2em;
//   text-align: center;
// }
// .measure-entry-wrapper {
//   // display: inline-flex;
// }
.btn--remove {
  background-color: transparent;
  margin: 0;
  padding: 0;
  color: #ff4444;
  // float: right;

  &:hover {
    color: #cc0000;
  }
}

.icon--remove {
  font-size: 1em;
}

.tooltip {
  opacity: unset;
  display: inline-block;
  position: unset;
  color: #49a5a7;
  font-weight: 700;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.odd {
  color: #fff;
  background-color: #0c8687;
}

.even {
  color: #fff;
  background-color: #49a5a7;
}

.all-rows {
  color: #0c8687;
}

.all-rows > .bg-color-1 {
  // color: #fff;
  background-color: #f2f8f6;
}

.all-rows > .bg-color--1 {
  // color: #fff;
  background-color: #fff;
}

.all-date-headers > .bg-color-1 {
  color: #fff;
  background-color: #0c8687;
}

.all-date-headers > .bg-color--1 {
  color: #fff;
  background-color: #49a5a7;
}

tr.highlight td {
  background-color: yellow !important;
}

.bp-date-box {
    background-color: #49A5A7; /* Green styling */
    border-radius: 8px;
    padding: 10px;
    color: white;
    margin-bottom: 20px;
    cursor: pointer;
    transition: background-color 0.3s, box-shadow 0.3s;
}
.bp-date-box:hover {
    background-color: #3E9394;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.bp-date-header {
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
}
.bp-tabs {
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
}
.tab-button {
    flex: 1;
    padding: 10px;
    background-color: #0C8687; /* Green tab background */
    color: white;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
    border-radius: 4px;
}
.tab-button.active {
    background-color: #086054; /* Active tab color */
}
.vitals-content {
    display: none; /* Initially hidden */
}
.vitals-content.active {
    display: block;
}
.vitals-row {
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    background-color: #FFFFFF;
    color: #333;
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 4px;
}
.vitals-item {
    display: flex;
    align-items: center;
    color: #0C8687;
    margin-right: 10px;
    min-width: 90px;
    text-align: left;
}
.vitals-item span {
    margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
}
</style>
